import { shape, number, string, arrayOf } from 'prop-types';

export const offerCompletionsPropTypes = arrayOf(
  shape({
    usedGroups: arrayOf(
      shape({
        offerGroup: shape({
          id: number,
          name: string
        })
      })
    )
  })
);

export const offerPropTypes = shape({
  offerId: number.isRequired,
  offerType: string,
  name: string,
  description: string,
  quantity: number,
  groupProducts: arrayOf(offerCompletionsPropTypes),
  price: number,
  extras: number,
  subtotal: number,
  discount: number,
  total: number,
  pointsSpent: number
});
